import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-apro-rep-leg',
  templateUrl: './modal-apro-rep-leg.component.html',
  styleUrls: ['./modal-apro-rep-leg.component.css']
})
export class ModalAproRepLegComponent implements OnInit {

  form: FormGroup;
  params: any;
  private apruebasol:string = environment.apruebasol;

  constructor(private http: HttpClient, private router: Router, private fb: FormBuilder, private modalService: NgbModal, public parametroAccionService : ParametroAccionService, private toastr: ToastrService) {
    this.form = this.fb.group({
      nroSol: [],
      rutEmpr: [],
      razonSocial: [],
      rutRep: [],
      nombreRep: [],
      correoRep: [],
      creationDate: []
    });
    this.params = this.parametroAccionService.obtenerDatos();
    if (this.params) {
      this.form.controls['nroSol'].setValue(this.params.SEQ_NRO_SOLICITUD_CDG);
      this.form.controls['rutEmpr'].setValue(this.params.RUT_EMPRESA+"-"+this.params.DV_EMPRESA);
      this.form.controls['razonSocial'].setValue(this.params.RAZON_SOCIAL);
      this.form.controls['rutRep'].setValue(this.params.RUT_REPRESENTANTE+"-"+this.params.DV_REPRESENTANTE);
      this.form.controls['nombreRep'].setValue(this.params.NOMBRE_REPRESENTANTE_LEGAL);
      this.form.controls['correoRep'].setValue(this.params.CORREO_ELECTRONICO);
      this.form.controls['creationDate'].setValue(this.params.CREATION_DATE);
      this.form.get('nroSol').disable();
      this.form.get('rutEmpr').disable();
      this.form.get('razonSocial').disable();
      this.form.get('rutRep').disable();
      this.form.get('nombreRep').disable();
      this.form.get('correoRep').disable();
      this.form.get('creationDate').disable();
    }    
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.http.post<any>(this.apruebasol, { 
      rut_empresa: this.params.RUT_EMPRESA,
      rut_representante_legal: this.params.RUT_REPRESENTANTE,
      nro_solicitud: this.params.SEQ_NRO_SOLICITUD_CDG
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.toastr.success("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" aprobada correctamente.");
          this.modalService.dismissAll();
        }else{
          this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
          this.modalService.dismissAll();
        }
      }else{
        this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
        this.modalService.dismissAll();
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
      this.modalService.dismissAll();
    });
  }

  onCloseModalA() {
    this.modalService.dismissAll();
  }
}
